/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { GEOS } from 'core/utils/constants';
import { TYPE_PROJECT } from 'common/utils/cloud-resource-types';

/**
 *
 * `PageTerraform` is the dashboard page for the Terraform route in HCP.
 *
 *
 * ```
 * <Page::Terraform
 *   @model={{this.model}}
 * />
 * ```
 *
 * @class PageTerraform
 *
 */

export default class PageTerraformComponent extends Component {
  @service config;
  @service userContext;
  @service('terraform-unification') terraformUnification;

  GEOS = GEOS;

  get deployGeo() {
    return this.config.app?.deployGeo ?? GEOS.US;
  }

  get terraformProjectsUrl() {
    const { organization, project } = this.args.model ?? {};

    if (!organization || !project) {
      return this.terraformUnification.getDeploymentUrl({
        geo: this.deployGeo,
      });
    }

    return this.terraformUnification.getResourceUrl({
      url: this.terraformUnification.getDeploymentUrl({ geo: this.deployGeo }),
      resourceType: TYPE_PROJECT,
      resourceIdentifiers: {
        terraformOrganizationName: organization?.name,
        projectId: project?.id,
      },
    });
  }
}
